import Round from './Round';
import { colors } from 'kaizen-ui-colors/lib';

class Project {
  public id: string;
  public isMobileWeb: boolean;
  public elapsedDays: number;
  public productType: string;
  public projectType: string;
  public quotaCount: string;
  public quotaPeriod: number;
  public round: Round;
  public state: string;
  public title: string;
  public url: string;

  constructor({
    id,
    is_mobile_web,
    elapsed_days,
    product_type,
    project_type,
    quota_count,
    quota_period,
    round,
    state,
    title,
    url,
  }: {
    id: string;
    is_mobile_web: boolean;
    elapsed_days: number;
    product_type: string;
    project_type: string;
    quota_count: string;
    quota_period: number;
    round: any;
    state: string;
    title: string;
    url: string;
  }) {
    this.id = id;
    this.isMobileWeb = is_mobile_web;
    this.elapsedDays = elapsed_days;
    this.productType = product_type;
    this.projectType = project_type;
    this.quotaCount = quota_count;
    this.quotaPeriod = quota_period;
    this.round = new Round(round);
    this.state = state;
    this.title = title;
    this.url = url;
  }

  PRODUCT_TYPE_MAPPING = {
    private: 'private',
    open: 'open',
    rbr_open: 'open',
    categorized_limited_open: 'targeting',
    rbr_categorized_limited_open: 'targeting',
    rbr_limited_sp_optimizer: 'growth',
    rbr_limited_sp_optimizer_team: 'growth',
    limited_open: 'growth',
    my_team: 'myteam',
  };

  PRODUCT_TYPE_LABEL_MAPPING = {
    private: 'プライベート',
    open: 'オープン',
    rbr_open: 'オープン',
    categorized_limited_open: 'ターゲティング',
    rbr_categorized_limited_open: 'ターゲティング',
    rbr_limited_sp_optimizer: 'グロースチーム',
    rbr_limited_sp_optimizer_team: 'グロースチーム',
    limited_open: 'グロースチーム',
    my_team: 'マイチーム',
  };

  PRODUCT_TYPE_COLOR_MAPPING = {
    private: colors.lemon_light__f9d94d,
    open: colors.mint__88e18e,
    targeting: colors.eggplant__c29eff,
    growth: colors.sky_dark__55bbff,
    myteam: colors.tangerine__fd925e,
    unknown: colors.lithium_light__e2e6ef,
  };

  PROJECT_STATE_MAPPING = {
    initial: '準備中',
    competition: '実施中',
    interim: 'インターバル',
    paused: '一時停止中',
    archived: '終了',
    round_running: 'ラウンド計測中',
    waiting_for_next_round_posts: 'インターバル',
    final_round_running: '終了予定',
  };

  PROJECT_STATE_BGCOLOR_MAPPING = {
    competition: colors.denim__5fa9ff,
    paused: colors.lava__fe7877,
  };

  public a11yType() {
    return this.PRODUCT_TYPE_MAPPING[this.productType] || 'unknown';
  }

  public productTypeLabel() {
    return this.PRODUCT_TYPE_LABEL_MAPPING[this.productType] || 'unknown';
  }

  public productTypeColor() {
    return this.PRODUCT_TYPE_COLOR_MAPPING[this.a11yType()];
  }

  public projectStateLabel() {
    return this.PROJECT_STATE_MAPPING[this.round.state === 'paused' ? this.round.state : this.state] || 'unknown';
  }

  public projectStateBgColor() {
    return this.PROJECT_STATE_BGCOLOR_MAPPING[this.round.state === 'paused' ? this.round.state : this.state] || null;
  }

  public isBanner() {
    return this.projectType.match(/^(replace_image|display_popup)$/);
  }
}

export default Project;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/domain/entity/Project.ts